export default [
  {
    path: '/middle/auth_result',
    component: () => import('../view/middle/auth_result.js'),
    name: 'authResult',
    meta: { pageName: 'auth_result' }
  },
  {
    path: '/middle/limit',
    component: () => import('../view/middle/limit.js'),
    name: 'limit',
    meta: { pageName: 'limit' }
  },
  {
    path: '/middle/repay',
    component: () => import('../view/middle/repay.js'),
    name: 'repayLimit',
    meta: { pageName: 'repayLimit' }
  },
  {
    path: '/middle/download',
    component: () => import('../view/middle/download.vue'),
    name: 'downloadMiddle',
    meta: { pageName: 'downloadMiddle' }
  },
  {
    path: '/middle/coupon',
    component: () => import('../view/middle/coupon.js'),
    name: 'couponMIddle',
    meta: { pageName: 'couponMIddle' }
  },
  {
    path: '/middle/sms_link_bridge',
    component: () => import('../view/middle/sms-link-bridge.js'),
    name: 'smsLinkBridge',
    meta: { pageName: 'smsLinkBridge' }
  }
]

